export const de = {
	childTest: `Willkommen zum Test`,
	welcomeToTest: `Willkommen zum Test`,
	literateChildTest: `Dysmate test`,
	youAreReady: `Du bist bereit`,
	ready: `Start`,
	chooseRole: `Rolle auswählen`,
	chooseRoleHelp: `Wählen Sie bitte, ob dieses Gerät der Testleiterin/dem Testleiter oder der Schülerin/dem Schüler zugeordnet ist`,
	chooseLanguage: `Sprache auswählen`,
	lang_no: `Norwegisch (Bokmål)`,
	lang_nn: `Norwegisch (Nynorsk)`,
	lang_se: `Schwedisch`,
	lang_de: `Deutsch`,
	lang_nl: `Niederländisch`,
	lang_en: `Englisch`,
	blue: `blau`,
	green: `grün`,
	pink: `rosa`,
	yellow: `gelb`,
	red: `rot`,
	violet: `lila`,
	orange: `orange`,
	gray: `grau`,
	grey: `grau`,
	brown: `braun`,
	dog: `hund`,
	shoe: `schuh`,
	tree: `baum`,
	door: `tür`,
	moon: `mond`,
	unknown: `Unbekannt`,
	testadministrator: `Testleiterin/Testleiter`,
	testcandidate: `Schülerin/Schüler`,
	testkey: `Testschlüssel`,
	emailaddress: `E-Mail-Addresse`,
	starttest: `Test starten`,
	candidateInstructions: `Trage den Code ein, den Dir Deine Lehrerin oder Dein Lehrer vorliest oder zeigt. Tippe “Zum Test”.`,
	gototest: `Zum Test`,
	jumptotest: `Zu dieser Aufgabe wechseln`,
	roomkey: `Testschlüssel: {0}`,
	waitforadminstart: `Warte, bis der Testleiter den Test startet`,
	done: `Fertig`,
	name: `Name`,
	sound: `Klang`,
	helpBox1: `Auf die Schülerin/den Schüler warten. Bitte den Code, der Ihnen angezeigt wird, laut vorlesen und ggf. der Schülerin/dem Schüler zeigen. Dieser wird zum Starten des Follow-Up-Tests benötigt.`,
	helpBoxList1: `Öffnen Sie die Seite www.dysmate.de auf einem anderen Gerät.`,
	helpBoxList2: `Wählen Sie „Testen“ `,
	helpBoxList3: `Testschlüssel eingeben ({0})`,
	helpBoxList4: `Klicken Sie auf „Zum Test“`,
	helpBoxList5: `Wenn Sie bereit sind, klicken Sie unten auf dieser Seite auf „Test starten“.`,
	infoAboutCandidate: `Informationen zum Testkandidaten:`,
	generalInformation: `Allgemeine Informationen`,
	notaBene: `NB!`,
	candidateReminder: `{0} Denken Sie daran, dass die Informationen des Testkandidat ausgefüllt werden müssen, nicht Ihre`,
	firstName: `Vorname`,
	lastName: `Nachname`,
	birthDate: `Geburtsdatum`,
	gender: `Geschlecht`,
	pickOne: `Wähle ein`,
	boy: `männlich`,
	girl: `weiblich`,
	unspecified: `divers`,
	education: `Ausbildung`,
	municipality: `Gemeinde`,
	county: `County`,
	school: `Schule`,
	educationLevel: `Bildungsniveau:`,
	kindergarten: `Kindergarten und 1.Klasse Grundschule`,
	primarySchool: `Grundschule (2.-5.Klasse)`,
	juniorHighSchool: `Mittelschule (6.-10.Klasse)`,
	highSchool: `Weiterführende Schule`,
	university: `Universität`,
	other: `Andere`,
	pickYear: `Jahr auswählen`,
	pickClass: `Klasse auswählen`,
	pickLevel: `Stufe auswählen`,
	pick: `Wählen`,
	lastYearBeforeSchool: `Letztes Jahr vor der Einschulung`,
	class: `Klassenstufe`,
	classNum: `{0}. Klasse`,
	bilinguagualHomeQuestion: `Sind Sie in einem ein- oder zweisprachigen Elternhaus aufgewachsen?`,
	unilingual: `Einsprachig`,
	bilingual: `Zweisprachig`,
	multilingual: `Mehrsprachig`,
	iConsent: `Ich bestätige`,
	consentText: `Als Testadministrator bestätigen Sie, dass Sie die erforderliche Zustimmung des Testkandidaten zur Erhebung personenbezogener Daten haben und dass diese wie beschrieben verwendet werden`,
	literatePrivacyPolicy: `Literate Datenschutzerklärung`,
	practiceTasks: `Beispielen`,
	startPracticeTasks: `Übungsaufgaben beginnen`,
	listenToInstructions: `Hör auf die Anleitung.`,
	waitingForCandidate: `Warten Sie auf die Schülerin/den Schüler`,
	logIn: `Anmelden`,
	loginWithBankId: `Melden Sie sich mit BankID an, indem Sie auf eine der folgenden Schaltflächen klicken`,
	thisIsForTestAdmins: `Dies ist für Testadministratoren (d. h. zertifizierte Benutzer mit einem Abonnement)`,
	pauseBeforeNextTest: `Die Aufgabe zum {0} ist nun beendet.`,
	max2Listens: `Maximal zwei Plays pro Audiotrack`,
	timeUsed: `Zeitaufwand: {0}`,
	start: `Start`,
	pause: `Pause`,
	stop: `Stoppen`,
	reset: `Zurücksetzen`,
	testIsFinished: `Die Aufgabe zum Laute vertauschen ist nun beendet!`,
	TesFinished_Instruction_ONCANDIATESIDE: `Geschafft! Du hast alle 4 Aufgaben beendet. Der Test ist nun vorbei!`,
	testFinishedInstruction: `Die Antworten wurden alle gespeichert. Sie können die Anwendung nun schließen oder einen weiteren Testdurchlauf mit einer weiteren Schülerin oder einem weiteren Schüler beginnen. Vielen Dank!	`,
	closeTest: `Test schließen`,
	hotkeyDescription: `Markieren Sie richtige und falsche Antworten, indem Sie auf die Schaltflächen unten klicken oder die folgenden Tastenkombinationen verwenden:`,
	hotkeyCorrect: `A: Richtig`,
	hotkeyWrong: `S: Falsch`,
	hotkeyDescSpoonerism: `Markieren Sie richtige und falsche Antworten, indem Sie auf die Schaltflächen unten klicken.`,
	hotkeyCorrectSpoonerism: `Richtig`,
	hotkeyWrongSpoonerism: `Falsch`,
	hotkeyButtonCorrect: `Richtig (A)`,
	hotkeyButtonWrong: `Falsch (S)`,
	hotkeyButtonUnanswered: `Unbeantwortet (D)`,
	taskNum: `Aufgabe: {0}`,
	taskNumOf: `Aufgabe: {0} von {1}`,
	correctAnswer: `korrekte Antwort: {0}`,
	nextTest: `Start`,
	correctAnswerGiven: `Richtige Antwort gegeben`,
	expectedAnswer: `Erwartete Antwort: {0}`,
	clickStartWhenReady: `Klicken Sie auf „Test starten“, wenn Sie und die Schülerin oder der Schüler bereit sind.`,
	clickStartWhenReadyEmpty: ``,
	workingMemoryClickStart: `Klicken Sie auf „Test starten“, wenn Sie und die Schülerin oder der Schüler bereit sind.`,
	testDone: `Der Test ist nun beendet.`,
	testName_WorkingMemory: `Zahlen und Wörter merken`,
	testName_WorkingMemoryNumbers: `Zahlen merken`,
	testName_WorkingMemoryWords: `Wörter merken`,
	testName_RapidNaming: `Bilder benennen`,
	testName_OneMinute: `Wörter vorlesen`,
	testName_Spoonerism: `Laute vertauschen`,
	testName_TestComplete: `Der Test ist abgeschlossen`,
	om_testname: `Wörter vorlesen`,
	om_intro: `Du siehst in dieser Aufgabe eine Liste mit vielen Wörtern. Deine Aufgabe besteht darin, diese Wörter so schnell und genau wie möglich laut vorzulesen. Die Wörter werden immer länger. In dieser Aufgabe gibt es keine Beispiele. Für diese Aufgabe hast Du eine Minute Zeit – arbeite also so schnell und genau, wie möglich.`,
	om_admin1: `Diese Aufgabe misst, wie schnell die Schülerin oder der Schüler einzelne Wörter vorlesen kann.`,
	om_admin2: `Die Schülerin oder der Schüler sieht in dieser Aufgabe eine Liste mit Wörtern. Die Wörter werden immer länger. Diese Wörter sollen so schnell und genau wie möglich vorgelesen werden. Ihre Aufgabe besteht darin, zu prüfen, ob die Wörter richtig vorgelesen wurden. Dies tun Sie, indem Sie bei jedem richtig vorgelesenen Wort die Taste „A“ und bei jedem falsch vorgelesenen Wort die Taste „S“ auf Ihrer Computertastatur klicken.`,
	rn_testname: `Bilder benennen`,
	rn_admin1: `Dieser Test misst, wie schnell die Schülerin oder der Schüler Bilder in verschiedenen Farben benennen kann. `,
	rn_admin2: `Die Schülerin oder der Schüler sieht in dieser Aufgabe Bilder, die in verschiedenen Farben erscheinen. Diese Bilder und deren Farben sollen so schnell und genau wie möglich benannt werden.`,
	rn_admin3: `Zuerst werden die Farben gezeigt und benannt, bevor die Schülerin oder der Schüler die Farben so schnell wie möglich benennen soll.
	Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin oder des Schülers richtig ist. Wenn die Antwort richtig ist, fahren Sie mit der Einführung der Bilder fort. Wenn die Antwort falsch ist, korrigieren Sie die Schülerin oder den Schüler, indem Sie die richtigen Namen der Farben nennen.`,
	rn_adjustIfNotCorrect: `Jetzt entweder mit der Einführung der Bilder fortfahren oder die Schülerin oder den Schüler korrigieren. `,
	rn_colors: `rot – blau – grün – gelb – braun `,
	rn_objects: `Hund – Schuh – Baum – Tür – Mond`,
	rn_objectsWithColors: `roter Hund – blauer Schuh – grüner Baum – gelbe Tür – brauner Mond`,
	rn_correctColors: `Die Farben wurden korrekt benannt`,
	rn_correctItems: `Die Bilder wurden korrekt benannt`,
	rn_admin4: ` Jetzt werden die Bilder gezeigt und benannt, bevor die Schülerin oder der Schüler die Bilder so schnell wie möglich benennen soll. Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin oder des Schülers richtig ist. Wenn die Antwort richtig ist, fahren Sie mit dem Beispiel fort. Wenn die Antwort falsch ist, korrigieren Sie die Schülerin oder den Schüler, indem Sie die richtigen Namen der Bilder nennen.`,
	rn_admin5: `Im Beispiel werden die Objekte mit den Farben kombiniert. Sie werden zunächst gezeigt und benannt, bevor die Schülerin oder der Schüler die Bilder und die Farben so schnell wie möglich benennen soll.`,
	rn_admin6: `Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin oder des Schülers richtig ist. Wenn die Antwort richtig ist, kann die eigentliche Aufgabe beginnen. Wenn die Antwort falsch ist, korrigieren Sie die Schülerin oder den Schüler, indem Sie die richtigen Namen der farbigen Bilder nennen.`,
	rn_admin10: `Zuerst werden die Farben gezeigt und benannt, bevor die Schülerin oder der Schüler die Farben so schnell wie möglich benennen soll.
	Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin oder des Schülers richtig ist. Wenn die Antwort richtig ist, fahren Sie mit der Einführung der Bilder fort. Wenn die Antwort falsch ist, korrigieren Sie die Schülerin oder den Schüler, indem Sie die richtigen Namen der Farben nennen.`,
	rn_admin7: `Die Beispielen ist nun beendet. Die Schülerin oder der Schüler sieht nun ein Tableau mit vielen farbigen Bildern, die sich wiederholen. Die Aufgabe besteht darin, diese von links nach rechts so schnell wie möglich zu benennen – ähnlich wie beim Lesen eines Textes.`,
	rn_admin8: `Der Testkandidat sieht auf seinem Bildschirm eine Reihe von Bildern, die er so schnell und genau wie möglich vorlesen muss.`,
	rn_admin9: `Auf die Antworten der Schülerin oder des Schülers und das Ende der Zeit warten.Sie sehen dasselbe Tableau, das auch die Schülerin oder der Schüler sieht. Ihre Aufgabe besteht darin, zu prüfen, ob die Benennungen richtig sind. Klicken Sie jedes falsch benannte Objekt an.`,
	rn_timeUsed: `Zeitaufwand: {0} Sekunden`,
	rn_intro1: `In dieser Aufgabe siehst Du Bilder. Deine Aufgabe besteht darin, so schnell und genau wie möglich zu sagen, was Du auf den Bildern siehst. Die Bilder erscheinen in verschiedenen Farben. Wenn Du die Bilder benennst, nenne immer auch die Farbe dazu. Für diese Aufgabe hast Du vier Minuten Zeit – arbeite also so schnell und genau wie möglich. Wir beginnen mit einer Einführung der Farben und Bilder und einem Beispiel, damit Du verstehst, wie die Aufgabe funktioniert.`,
	rn_intro2: ``,
	rn_intro3: `Höre genau auf die Namen der Objekte: Hund – Schuh – Baum – Tür – Mond. Nun bist Du dran: Benenne die Objekte so schnell und akkurat, wie Du kannst!`,
	rn_intro4: `Nun siehst Du die Objekte in verschiedenen Farben. Höre genau auf die Namen der farbigen Objekte: roter Hund – blauer Schuh – grüner Baum – gelbe Tür – brauner Mond. Nun bist Du dran: Benenne die farbigen Objekte so schnell und akkurat, wie Du kannst!`,
	rn_intro5: `Wenn die Aufgabe gleich beginnt, siehst Du die farbigen Bilder mehrere Male auf dem Bildschirm. Deine Aufgabe besteht darin, diese so schnell und genau wie möglich von links nach rechts zu benennen. `,
	sp_testname: `Laute vertauschen `,
	sp_admin_listen: `Auf die Antworten der Schülerin oder des Schülers warten.	Ihre Aufgabe besteht darin, zu prüfen, ob die Laute richtig vertauscht und die Wörter richtig nachgesprochen wurden.`,
	sp_admin1: `Die Schülerin oder der Schüler hört in dieser Aufgabe Wortpaare. Diese Wortpaare sollen nachgesprochen werden, indem die Anfangslaute vertauscht werden. Die neuen Wörter sind entweder reale Wörter oder Nichtwörter.`,
	sp_admin1part2: `Ihre Aufgabe besteht darin, zu prüfen, ob die Laute richtig vertauscht und die Wörter richtig nachgesprochen wurden. Dies tun Sie, indem Sie bei jeder richtigen Antwort die Taste „A“ und bei jeder falschen Antwort die Taste „S“ auf Ihrer Computertastatur klicken. Die richtige, erwartete Antwort wird Ihnen jeweils angezeigt. Außerdem sehen Sie stets, wie viele Wortpaare noch kommen.`,
	sp_1correct: `1 richtig`,
	sp_2correct: `2 richtig`,
	sp_bothWrong: `Beide falsch`,
	sp_admin2: `Dem Testkandidaten werden einige vorzulesende Wörter mit einem dazwischen geschalteten Ton vorgelesen. Sie müssen dann zuhören, um zu sehen, ob die wiedergegebenen Wörter mit denen auf Ihrem Bildschirm übereinstimmen.`,
	sp_admin3: `Hören Sie dem Testteilnehmer zu und hören Sie, ob er das richtige Wort sagt, das auf dem Bildschirm angezeigt wird.`,
	sp_instruction: ``,
	sp_intro1: `Du hörst in dieser Aufgabe immer ein Wortpaar. Deine Aufgabe besteht darin, diese Wortpaare nachzusprechen und dabei jeweils die Anfangslaute der Wörter zu vertauschen. Die neuen Wörter sind entweder Wörter, die es gibt oder es sind Quatschwörter. `,
	sp_intro_reminder: `es ist nicht der Brief`,
	sp_intro_reminder2: `erster Ton`,
	sp_intro3: `Tippe „Start“, um mit der Aufgabe zu beginnen.`,
	click_start: `Tippe „Start“, um mit der Aufgabe zu beginnen.`,
	ws_testname: `Zahlen und Wörter merken`,
	ws_testname_admin: `Zahlen merken`,
	wsn_testname: `Zahlen merken`,
	wsw_testname: `Wörter merken`,
	ws_admin1: `Diese Aufgabe misst die Leistungen des Arbeitsgedächtnisses.`,
	wsn_admin2: `Die Schülerin/der Schüler hört in dieser Aufgabe Zahlen, die sie/er rückwärts wiederholen soll. Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin/des Schülers richtig ist. Die richtige Antwort wird Ihnen jeweils angezeigt. Tippen Sie nach jeder Antwort entweder „richtig“ oder „falsch“. Achtung: Nach zwei falschen Antworten in Folge wird der Test automatisch abgebrochen.`,
	wsn_admin2part2: ``,

	wsw_admin2: `Die Schülerin oder der Schüler hört in dieser Aufgabe Wortfolgen, die sie oder er rückwärts nachsprechen soll. Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin oder des Schülers richtig ist. Dies tun Sie, indem Sie für eine richtige Antwort die Taste „A“ und für eine falsche Antwort die Taste „S“ auf Ihrer Computertastatur klicken. Die richtige, erwartete Antwort wird Ihnen jeweils angezeigt. Außerdem sehen Sie stets, wie viele Wortfolgen noch kommen.`,
	wsw_admin2part2: ``,
	wsn_admin3: `Die Schülerin/der Schüler hört in dieser Aufgabe Zahlen, die sie/er rückwärts wiederholen soll. Ihre Aufgabe besteht darin, zu prüfen, ob die Antwort der Schülerin/des Schülers richtig ist. Die richtige Antwort wird Ihnen jeweils angezeigt.`,
	wsw_admin3: `Hören Sie dem Testteilnehmer zu und hören Sie, ob er die richtige Wortfolge sagt, die auf dem Bildschirm angezeigt wird.`,
	wsn_intro1: `Bei dieser Aufgabe hörst Du eine Folge von Zahlen. Deine Aufgabe besteht darin, diese Folgen in umgekehrter Reihenfolge nachzusprechen.`,
	wsn_intro2: `Wenn ich zum Beispiel "1 - 3" sage, sagst Du "3 - 1". Achtung: Die Zahlenfolgen werden immer länger!`,
	wsw_intro1: `Bei dieser Aufgabe hörst Du eine Folge von Wörtern. Deine Aufgabe besteht darin, diese Folgen in umgekehrter Reihenfolge nachzusprechen. Du kennst diese Aufgabe schon mit Zahlen. Achtung: Die Wortfolgen werden immer länger!`,
	wsw_intro2: `Wenn ich zum Beispiel Ball - Tisch sage, sagst Du Tisch - Ball`,
	wsn_test1: `Spreche die Zahlenfolgen, die Du hörst, in umgekehrter Reihenfolge nach!`,
	wsw_test1: `Spreche die Wortfolgen, die Du hörst, in umgekehrter Reihenfolge nach!`,
	warning1: `Warnung 1 -`,
	warning1text: `Anscheinend wurde der Test mit diesem Testschlüssel noch nicht richtig gestartet. Der Testadministrator muss den richtigen Test von starten`,
	myTests: `Mein Tester`,
	warning2: `Warnung 2`,
	warning2text: `- Anscheinend haben Sie Cross-Site-Tracking in Ihrem Browser deaktiviert. Um unsere Dienste nutzen zu können, müssen Sie es aktivieren. Drücken Sie`,
	linkForInstructions: `hier`,
	remainingTime: `Verbleibende Zeit: `,
	trialIsNowOver: `Die Beispiele sind nun beendet`,
};

export default de;
